module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9n1n3r6r-8611c6b1763a21d8e3f3997c68c908f9.svg";